import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import ProjectList from "../projects/projects";
import ReactMarkdown from "react-markdown";
import Badge from "../Badge";

const ProjectDetail = () => {
	const { projectId } = useParams();
	const [project, setProject] = useState();

	useEffect(() => {
		console.log(ProjectList, projectId);
		const data = ProjectList.find(
			(project) => project.id === parseInt(projectId)
		);
		setProject(data);
	}, [projectId]);

	return (
		<section className="wrapper pt-24">
			<h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-center">
				{project?.title}
			</h1>
			<Carousel
				autoPlay
				infiniteLoop
				dynamicHeight={false}
				interval="3000"
				showThumbs={true}
			>
				{project?.extra_images?.map((image) => (
					<div>
						<img
							className="bg-cover bg-center max-h-96 w-full rounded"
							src={image}
							alt=""
						/>
					</div>
				))}
			</Carousel>
			<div className="flex flex-wrap bg-gray-300 rounded mt-10 p-6">
				<div className="w-full md:w-8/12">
					<div className="markdown prose prose-lg xl:prose-xl">
						<ReactMarkdown children={project?.description} />
					</div>
				</div>
				<div className="w-full md:w-4/12">
					<div className="tags">
						{project?.tags?.map((tag, index) => (
							<span
								key={index}
								className="inline-block bg-gray-700 rounded-full px-2 py-1 text-sm font-semibold text-gray-200 mr-2 mb-2 shadow-lg"
							>
								# {tag}
							</span>
						))}
					</div>

					<div className="skill-group mt-6">
						{project?.technologies?.map((tech, index) => (
							<Badge key={index} text={tech} />
						))}
					</div>

					<div className="source-codes my-6">
						<h4 className="text-xl text-gray-700 font-semibold mb-4">
							Links
						</h4>
						{project?.git &&
							project?.git?.map((code, index) => (
								<a
									key={index}
									href={`${code.url}`}
									target="_blank"
									rel="noreferrer"
									className="bg-gray-700 text-white p-2 rounded shaow text-sm mb-2 mr-4"
								>
									<i className="fab fa-github text-lg mr-1" />{" "}
									{code?.title}
								</a>
							))}
					</div>

					{project?.url && (
						<a
							href={`${project?.url}`}
							target="_blank"
							rel="noreferrer"
							className="bg-gray-700 text-white p-2 rounded shaow text-sm mb-2"
						>
							<i className="fas fa-eye text-lg mr-1" /> Preview
						</a>
					)}
				</div>
			</div>
		</section>
	);
};

export default ProjectDetail;
